import axios from 'axios';
import { auth } from './firebase';
import { API_BASE_URL } from '../util/api.util';
import { JURISDICTIONS, JurisdictionId } from '../types/jurisdiction';

const VALID_IDS = new Set<JurisdictionId>(JURISDICTIONS.map((j) => j.id));

/**
 * Fetches the list of jurisdictions the logged-in user is allowed to select.
 * Returns the raw allowed ids from the backend (filtered to known ids).
 * Throws if the user is not authenticated or the request fails.
 */
export async function fetchAllowedJurisdictions(): Promise<JurisdictionId[]> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not authenticated');
  }
  const token = await user.getIdToken();
  const { data } = await axios.get<{ allowed: string[] }>(
    `${API_BASE_URL}/api/jurisdictions`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const allowed = Array.isArray(data?.allowed) ? data.allowed : [];
  return allowed.filter((id): id is JurisdictionId => VALID_IDS.has(id as JurisdictionId));
}
